import {
  PiStairsDuotone,
  PiDoorOpenDuotone,
  PiLineSegmentFill,
  PiPersonSimpleRunDuotone,
  PiFireExtinguisherDuotone,
  PiFanDuotone,
  PiDropDuotone,
  PiLightningDuotone,
} from "react-icons/pi";
// 機具圖示：react-icons/pi 沒有挖土機/推土機/吊車/吊卡車/堆高機，改用 Tabler 的專用圖示，
// 讓操作人員在畫布上能一眼分辨機具種類。
import {
  TbBackhoe,
  TbBulldozer,
  TbCarCrane,
  TbCrane,
  TbForklift,
  TbTruck,
} from "react-icons/tb";

export const SYMBOL_TYPES = {
  STAIRS: {
    id: "stairs",
    name: "樓梯",
    icon: PiStairsDuotone,
    category: "建築結構",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#8c8c8c",
  },
  DOOR: {
    id: "door",
    name: "門",
    icon: PiDoorOpenDuotone,
    category: "建築結構",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#8c8c8c",
  },
  VENTILATION: {
    id: "ventilation",
    name: "通風口",
    icon: PiFanDuotone,
    category: "建築結構",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#8c8c8c",
  },
  EXIT: {
    id: "exit",
    name: "出口",
    icon: PiPersonSimpleRunDuotone,
    category: "安全設施",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#52c41a",
  },
  FIRE_EXTINGUISHER: {
    id: "fire_extinguisher",
    name: "滅火器",
    icon: PiFireExtinguisherDuotone,
    category: "安全設施",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#ff4d4f",
  },
  WATER: {
    id: "water",
    name: "水源",
    icon: PiDropDuotone,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#13c2c2",
  },
  ELECTRICAL: {
    id: "electrical",
    name: "電力設施",
    icon: PiLightningDuotone,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#faad14",
  },
  EXCAVATOR: {
    id: "excavator",
    name: "挖土機",
    icon: TbBackhoe,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#d46b08",
    isEquipment: true,
  },
  BULLDOZER: {
    id: "bulldozer",
    name: "推土機",
    icon: TbBulldozer,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#ad4e00",
    isEquipment: true,
  },
  CRANE: {
    id: "crane",
    name: "吊車",
    icon: TbCrane,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#722ed1",
    isEquipment: true,
  },
  MOBILE_CRANE: {
    id: "mobile_crane",
    name: "吊卡車",
    icon: TbCarCrane,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#9254de",
    isEquipment: true,
  },
  TRUCK: {
    id: "truck",
    name: "卡車",
    icon: TbTruck,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#1890ff",
    isEquipment: true,
  },
  FORKLIFT: {
    id: "forklift",
    name: "堆高機",
    icon: TbForklift,
    category: "設備",
    compatibleLayouts: ["plane", "line", "tunnel"],
    color: "#08979c",
    isEquipment: true,
  },
  CROSS_LANE_LINK: {
    id: "cross_lane_link",
    name: "聯絡道",
    icon: PiLineSegmentFill,
    category: "建築結構",
    compatibleLayouts: ["tunnel"],
    color: "#8c8c8c",
    renderType: "vertical_line",
  },
};

export const SYMBOL_CATEGORIES = {
  STRUCTURE: "建築結構",
  SAFETY: "安全設施",
  EQUIPMENT: "設備",
};

export const getSymbolsForLayout = (layoutType) => {
  return Object.values(SYMBOL_TYPES).filter((symbolType) =>
    symbolType.compatibleLayouts.includes(layoutType),
  );
};

export const getSymbolById = (symbolId) => {
  return Object.values(SYMBOL_TYPES).find((symbol) => symbol.id === symbolId);
};

export const SYMBOL_SIZE = 24;
export const SYMBOL_HALF_SIZE = SYMBOL_SIZE / 2;
